const SolidBackgroundModal = ({ children, className }: { children: React.ReactNode; className?: string }) => {
    return (
        <div
            className="sm:bg-primary flex justify-center sm:items-center sm:p-3 overflow-auto"
            style={{ minHeight: 'calc(var(--vh, 1vh) * 100)' }}
        >
            <main
                className={`h-full sm:h-auto w-full max-w-[600px] p-6 md:p-10 bg-white sm:m-auto sm:rounded sm:rounded-tl-modal sm:rounded-br-modal ${className ?? ''}`}
            >
                {children}
            </main>
        </div>
    )
}

export default SolidBackgroundModal
